import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MyOrdersFiltersBaseComponent } from '../my-orders-filters-base.component';
import { DatePreset } from '@app/my-orders/pages/order-status/constants/date-preset.enum';
import { MatCalendar } from '@angular/material/datepicker';
import { Moment } from 'moment';

@Component({
  selector: 'app-my-orders-filters-desktop-tablet',
  templateUrl: './my-orders-filters-desktop-tablet.component.html',
  styleUrls: ['./my-orders-filters-desktop-tablet.component.scss'],
})
export class MyOrdersFiltersDesktopTabletComponent
  extends MyOrdersFiltersBaseComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('calendar') calendar: MatCalendar<Moment>;
  DatePreset = DatePreset;

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    // Apply any pending calendar navigation that occurred before the view was initialized
    this.applyPendingNavigation();
  }

  /**
   * Navigates the calendar to the month containing the given date
   * @param date The date to navigate to
   */
  protected override navigateCalendarToStartDate(date: Moment): void {
    if (this.calendar) {
      // Use the calendar's active date property to navigate to the date's month
      this.calendar.activeDate = date;
      this.calendar.updateTodaysDate(); // Force calendar to refresh
    }
  }
}
